/**
 * AI 生文- 修改会话名称
 * @returns
 */
import {
  Flex,
  Button,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormErrorMessage,
  Textarea,
  FormLabel,
  RadioGroup,
  Stack,
  Radio,
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from "@chakra-ui/react";
import { useState } from "react";
import { Field, Form, Formik, FormikErrors } from "formik";
import { Knowledge } from "@/types/writing";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  editForm: Knowledge;
};



const KnowledgeEditModal = (props: Props) => {
  const { isOpen, onClose, editForm } = props;

  const addForm = {
    id: editForm?.id || "",
    user_id: editForm?.id,
    title: editForm?.title || "",
    isPublic: editForm?.isPublic || "私有",
    intro: editForm?.intro || "",
    docOverlapNum: editForm?.docOverlapNum || 0,
    docRecallMaxNum: editForm?.docRecallMaxNum || 0,
    docRecallMinNum: editForm?.docRecallMinNum || 0.0,
    resRandomness: editForm?.resRandomness || 0.0,
  };

  const handleValidate1 = (values: Knowledge) => {
    const errors: FormikErrors<{ title: string; intro: string }> = {};
    if (!values.title) {
      errors.title = "标题不能为空";
    }
    if (!values.intro) {
      errors.intro = "描述不能为空";
    }
    return errors;
  };

  const handleAddSubmit = (values: Knowledge) => {
    console.log(values)
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg="#fff">
        <ModalHeader color="#27314D" fontSize={"18px"}>
          编辑
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody pb={6}>
          <Formik
            initialValues={addForm}
            onSubmit={handleAddSubmit}
            validate={handleValidate1}
          >
            {({ submitForm, setFieldValue, values }) => (
              <Form>
                <Field name="title">
                  {({ field, form }: any) => (
                    <FormControl
                      // mt={"20px"}
                      isInvalid={form.errors.title && form.touched.title}
                    >
                      <FormLabel fontSize={"14px"}>标题</FormLabel>
                      <Input
                        {...field}
                        h="46px"
                        // bg="rgba(0, 0, 0, 0.3)"
                        color="#27314D"
                        fontSize={"14px"}
                        // border="none"
                        placeholder="请输入"
                        // borderRadius={0}
                        maxLength={50}
                      />
                      <FormErrorMessage>{form.errors.title}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <FormControl mt={"20px"}>
                  <FormLabel fontSize={"14px"}>是否公开</FormLabel>
                  <RadioGroup
                    value={values.isPublic}
                    onChange={(value) => {
                      setFieldValue("isPublic", value);
                    }}
                  >
                    <Stack direction="row">
                      <Radio value="公开">
                        <Box fontSize={"14px"}>公开</Box>
                      </Radio>
                      <Radio value="私有">
                        <Box fontSize={"14px"}>私有</Box>
                      </Radio>
                    </Stack>
                  </RadioGroup>
                </FormControl>
                <Field name="intro">
                  {({ field, form }: any) => (
                    <FormControl
                      mt={"20px"}
                      isInvalid={form.errors.intro && form.touched.intro}
                    >
                      <FormLabel fontSize={"14px"}>描述</FormLabel>
                      <Textarea
                        {...field}
                        h="46px"
                        // bg="rgba(0, 0, 0, 0.3)"
                        color="#27314D"
                        fontSize={"14px"}
                        // border="none"
                        placeholder="请输入"
                        // borderRadius={0}
                      />
                      <FormErrorMessage>{form.errors.intro}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Accordion mt={"20px"} allowMultiple>
                  <AccordionItem border={"none"}>
                    <Box>
                      <AccordionButton p="0" fontSize={"14px"}>
                        <AccordionIcon />
                        <Box as="span" flex="1" textAlign="left">
                          RAG设置
                        </Box>
                      </AccordionButton>
                    </Box>
                    <AccordionPanel pb={4} border={"none"}>
                      <FormControl>
                        <FormLabel fontSize={"14px"}>
                          文档切割时重叠数量
                        </FormLabel>
                        <NumberInput
                          value={values.docOverlapNum}
                          onChange={(value) => {
                            setFieldValue("docOverlapNum", value);
                          }}
                          min={0}
                        >
                          <NumberInputField color="#27314D" fontSize={"14px"} />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </FormControl>
                      <FormControl mt={"10px"}>
                        <FormLabel fontSize={"14px"}>
                          文档召回最大数量
                        </FormLabel>
                        <NumberInput
                          value={values.docRecallMaxNum}
                          onChange={(value) => {
                            setFieldValue("docRecallMaxNum", value);
                          }}
                        >
                          <NumberInputField color="#27314D" fontSize={"14px"} />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </FormControl>
                      <FormControl mt={"10px"}>
                        <FormLabel fontSize={"14px"}>
                          文档召回最小分数
                        </FormLabel>
                        <NumberInput
                          value={values.docRecallMinNum}
                          onChange={(value) => {
                            setFieldValue("docRecallMinNum", value);
                          }}
                          min={0}
                          max={1}
                          step={0.1}
                          precision={1}
                        >
                          <NumberInputField color="#27314D" fontSize={"14px"} />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </FormControl>
                    </AccordionPanel>
                  </AccordionItem>

                  <AccordionItem border={"none"} mt="10px">
                    <Box>
                      <AccordionButton p="0" fontSize={"14px"}>
                        <AccordionIcon />
                        <Box as="span" flex="1" textAlign="left">
                          LLM设置
                        </Box>
                      </AccordionButton>
                    </Box>
                    <AccordionPanel pb={4}>
                      <FormControl mt={"10px"}>
                        <FormLabel fontSize={"14px"}>
                        响应时的创造性/随机性
                        </FormLabel>
                        <NumberInput
                          value={values.resRandomness}
                          onChange={(value) => {
                            setFieldValue("resRandomness", value);
                          }}
                          min={0}
                          max={1}
                          step={0.1}
                          precision={1}
                        >
                          <NumberInputField color="#27314D" fontSize={"14px"} />
                          <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                          </NumberInputStepper>
                        </NumberInput>
                      </FormControl>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>

                <Flex mt="40px" justifyContent={"flex-end"}>
                  <Button
                    w="76px"
                    h="37px"
                    mr="15px"
                    bg="#CBD1DF"
                    color={"#27314D"}
                    fontSize="12px"
                    fontWeight={"normal"}
                    borderRadius={0}
                    _hover={{
                      bg: "#CBD1DF",
                      color: "#8E94A9",
                    }}
                    onClick={handleClose}
                  >
                    取消
                  </Button>
                  <Button
                    w="76px"
                    h="37px"
                    bg="#496AE1"
                    color={"#FFFFFF"}
                    fontSize="12px"
                    fontWeight={"normal"}
                    borderRadius={0}
                    _hover={{
                      bg: "#3F5BC1",
                      color: "#E6E6E6",
                    }}
                    type="submit"
                  >
                    完成
                  </Button>
                </Flex>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default KnowledgeEditModal;
